export default __webpack_public_path__ + "static/media/info-tooltip-deuda.64d91d5c.svg";